// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/shared/ResumeOnboardingButton.jsx
//  MICROSERVICIO ONBOARDING v3 — Botón condicional de retorno  [ACTUALIZADO v2]
//  docs/onboarding-master-v2.md, Parte I §7.3 + Parte III §1
//
//  Resuelve DOS estados, no uno:
//    · in_progress          → "Continuar mi diagnóstico →"
//                             lleva a /diagnostico y reanuda donde se quedó.
//    · completed_no_signup  → "Tu plan de entrenamiento sigue listo →"
//                             lleva directo a la vista resumen de 1 pantalla,
//                             NO al flujo completo otra vez.
//    · sin sesión guardada  → no se renderiza nada. Un visitante que nunca
//                             empezó no debe ver este botón.
//
//  Se inserta condicionalmente en el header existente; NO reemplaza ni
//  rediseña nada de lo que ya está en producción (Parte III §1 y §4).
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { useResumeState } from '../../state/onboardingStore';
import {
  RETURN_BUTTON_IN_PROGRESS,
  RETURN_BUTTON_COMPLETED,
} from '../onboarding/onboardingContent';
import './ResumeOnboardingButton.css';

export default function ResumeOnboardingButton({ className = '' }) {
  const resumeState = useResumeState();

  if (!resumeState) return null;

  const isCompleted = resumeState === 'completed_no_signup';

  // [v2.2] El copy del estado completado ya no interpola la aspiracion.
  const label = isCompleted ? RETURN_BUTTON_COMPLETED : RETURN_BUTTON_IN_PROGRESS;

  // El estado completed_no_signup entra por la vista resumen (Parte I §7.3).
  const to = isCompleted ? '/diagnostico?resume=summary' : '/diagnostico';

  return (
    <Link
      to={to}
      className={`ob-resume-btn${isCompleted ? ' ob-resume-hot' : ''} ${className}`.trim()}
      title={label}
    >
      {label}
    </Link>
  );
}
